module.exports = __webpack_public_path__ + "static/img/11.ca3646d.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting602/images/11.png
// module id = 75gs
// module chunks = 4